<div class="container">
    <div *ngIf="isLoading" class="row center">
        <div class="spinner-border text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div *ngIf="!isLoading" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="col-md-9 col-xs-9 mgb-10">
                <h2>Diamond Match List</h2>
            </div>
            <div class="col-md-12 col-xs-12">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th class="center pd1p">#</th>
                                <th>Event ID</th>
                                <th>Event Name</th>
                                <th>Competition Name</th>
                                <th>Market Id</th>
                                <th>Sport Name</th>
                                <th>Open Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of matchList; let i = index">
                                <td class="center pd1p">{{ i+1 }}</td>
                                <td>{{ data.event_id }}</td>
                                <td>{{ data.event_name }}</td>
                                <td>{{ data.competition_name }}</td>
                                <td>{{ data.market_id }}</td>
                                <td><span class="badge badgeback">{{ data.sport_name }}</span></td>
                                <td>{{ data.open_date }}</td>
                                <td><button id="btn{{ i }}" [disabled]="checkExists(data.event_id)"
                                        (click)="addMatch(data, i)"
                                        class="btn btn-{{ showColor(data.event_id) }} fbtn">{{
                                        actionTitle(data.event_id)
                                        }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>